module.exports = __webpack_public_path__ + "media/token_keno_action-f4d7a85c9dca5de49ccaf3716f7d9c4f.mp3";